import { render, staticRenderFns } from "./REAIQuery.vue?vue&type=template&id=fa4a4352&scoped=true"
import script from "./REAIQuery.vue?vue&type=script&lang=js"
export * from "./REAIQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4a4352",
  null
  
)

export default component.exports